import { useCallback, useState } from 'react';

/* 
This hook returns the following:

isMenuOpen: boolean
anchorEl: null or HTMLElement

The function below should be called in the button that triggers the menu:

toggle: () => !isMenuOpen

The function below should be called in the button that triggers the menu, 
and expects the click event as a parameter. So the anchor element can be set:

setAnchor: (event: React.SyntheticEvent) => event.target


*/

export const useMenuToggle = () => {
  const [isMenuOpen, toggleMenu] = useState(false);
  const [anchorEl, setAnchor] = useState<HTMLElement>(null);
  const toggle = useCallback(() => toggleMenu((prev) => !prev), []);
  const close = useCallback(() => toggleMenu(false), []);

  return { isMenuOpen, toggle, setAnchor, close, anchorEl };
};
